import Vue from 'vue';
import Flickity from 'flickity';

Vue.component('ticker-component', {
    props: {
        reverse: {
            type: Boolean,
            default: false
        },
        speed: {
            type: Number,
            default: 0.4
        },
        pausable: {
            type: Boolean,
            default: true
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            tickerSpeed: this.speed,
            flickity: null,
            isPaused: false
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

        if(this.pausable){
            this.$refs.ticker.addEventListener('mouseenter', this.pause, false);
            this.$refs.ticker.addEventListener('focusin', this.pause, false);
            this.$refs.ticker.addEventListener('mouseleave', this.play, false);
            this.$refs.ticker.addEventListener('focusout', this.play, false);
        }
        window.requestAnimationFrame(() => {
            this.initFlickity();
            this.flickity.on('dragStart', () => {
                this.isPaused = true;
            });
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        update() {
            if (this.isPaused) {
                return;
            }

            if (this.flickity.slides) {
                if (this.reverse) {
                    this.flickity.x = (this.flickity.x - this.tickerSpeed) % this.flickity.slideableWidth;
                } else {
                    this.flickity.x = (this.flickity.x + this.tickerSpeed) % this.flickity.slideableWidth;
                }
                this.flickity.selectedIndex = this.flickity.dragEndRestingSelect();
                this.flickity.updateSelectedSlide();
                this.flickity.settle(this.flickity.x);
            }

            window.requestAnimationFrame(this.update);
        },

        pause() {
            this.isPaused = true;
        },

        play() {
            if (this.isPaused) {
                this.isPaused = false;
                window.requestAnimationFrame(this.update);
            }
        },

        initFlickity() {
            this.flickity = new Flickity(this.$refs.ticker, {
                autoPlay: false,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                wrapAround: true,
                selectedAttraction: 0.015,
                friction: 0.25,
                resize: window.matchMedia('(min-width: 768px)').matches
            });
            this.flickity.x = 0;
            
            window.requestAnimationFrame(this.update);
        },

        openTestimonial(event) {
            let slide = event.currentTarget.getAttribute('data-slide-index');
            this.$root.openTestimonials(slide);
        },

        destroyTicker() {
            if (!this.flickity) {
                return;
            }

            this.flickity.destroy();
            this.flickity = null;
        },
    }
});
